// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion_accordionWrapper__tLHry {
  padding: 0px 24px;
  gap: 10px;
  border-radius: 10px;
}

.accordion_accordionDetails__MZ77h {
  padding-bottom: 8px;
}

.accordion_accordionDetailsContained__WC2H- {
  padding-bottom: 4px;
  padding-left: 0px;
  padding-right: 0px;
  background-color: white;
}

.accordion_noBorder__GsLOW {
  box-shadow: none;
  border: none;
  padding: 0;
}

.accordion_noBorder__GsLOW.Mui-expanded {
  margin-bottom: 0;
  margin-top: 0;
}

.accordion_noBorder__GsLOW .MuiAccordionSummary-root {
  min-height: auto;
  padding-left: 0;
  padding-right: 0;
}

.accordion_noBorder__GsLOW .MuiAccordionSummary-content.Mui-expanded {
  margin-top: 16px;
  margin-bottom: 16px;
}

.accordion_linkIcon__vTEHq {
  color: var(--mui-palette-primary-600);
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/accordion/accordion.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".accordionWrapper {\n  padding: 0px 24px;\n  gap: 10px;\n  border-radius: 10px;\n}\n\n.accordionDetails {\n  padding-bottom: 8px;\n}\n\n.accordionDetailsContained {\n  padding-bottom: 4px;\n  padding-left: 0px;\n  padding-right: 0px;\n  background-color: white;\n}\n\n.noBorder {\n  box-shadow: none;\n  border: none;\n  padding: 0;\n}\n\n.noBorder:global.Mui-expanded {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.noBorder :global .MuiAccordionSummary-root {\n  min-height: auto;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.noBorder :global .MuiAccordionSummary-content.Mui-expanded {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.linkIcon {\n  color: var(--mui-palette-primary-600);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordionWrapper": `accordion_accordionWrapper__tLHry`,
	"accordionDetails": `accordion_accordionDetails__MZ77h`,
	"accordionDetailsContained": `accordion_accordionDetailsContained__WC2H-`,
	"noBorder": `accordion_noBorder__GsLOW`,
	"linkIcon": `accordion_linkIcon__vTEHq`
};
export default ___CSS_LOADER_EXPORT___;
